import {
  getSizeFieldsForProfile,
  sumSizeStock,
} from "../../../Routes/Marketplace/libs/productSizes";
import { COLOR_SELECT_OPTIONS } from "../utils/categoryFormConfig";
import { PRODUCT_FIELD_LIMITS } from "../utils/productForm";

const CharCount = ({ value, max }) => (
  <span className="dashboard-char-count">
    {(value || "").length}/{max}
  </span>
);

const renderAttributeField = (field, value, onAttributeChange) => {
  const common = {
    key: field.key,
    className: "dashboard-form-field",
  };
  const maxLen = field.maxLength ?? PRODUCT_FIELD_LIMITS.attribute;

  if (field.type === "select") {
    return (
      <label {...common}>
        <span>
          {field.label}
          {field.required ? " *" : ""}
        </span>
        <select
          value={value || ""}
          onChange={(e) => onAttributeChange(field.key, e.target.value)}
          required={field.required}
        >
          <option value="">Select</option>
          {(field.options || []).map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </label>
    );
  }

  if (field.type === "date") {
    return (
      <label {...common}>
        <span>
          {field.label}
          {field.required ? " *" : ""}
        </span>
        <input
          type="date"
          value={value || ""}
          onChange={(e) => onAttributeChange(field.key, e.target.value)}
          required={field.required}
        />
      </label>
    );
  }

  return (
    <label {...common}>
      <span>
        {field.label}
        {field.required ? " *" : ""}
      </span>
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onAttributeChange(field.key, e.target.value)}
        placeholder={field.placeholder}
        maxLength={maxLen}
        required={field.required}
      />
    </label>
  );
};

const CategoryProductFields = ({ profile, form, onChange, onAttributeChange }) => {
  if (!profile || !form.category) return null;

  const sizeFields = profile.showSizes
    ? getSizeFieldsForProfile(profile.sizeMode || "clothing")
    : [];
  const sizeTotal = profile.showSizes ? sumSizeStock(form, sizeFields) : 0;

  return (
    <>
      <section className="dashboard-card dashboard-category-panel">
        <div className="dashboard-category-panel__header">
          <h2 className="dashboard-card__title">{profile.title}</h2>
          <p className="dashboard-form-hint">{profile.hint}</p>
        </div>

        <div className="dashboard-form-grid">
          {profile.showBrand && (
            <label className="dashboard-form-field">
              <span>
                Brand{profile.brandRequired ? " *" : ""}
                <CharCount value={form.brand} max={PRODUCT_FIELD_LIMITS.brand} />
              </span>
              <input
                type="text"
                name="brand"
                value={form.brand}
                onChange={onChange}
                placeholder="e.g. Samsung, Nestlé"
                maxLength={PRODUCT_FIELD_LIMITS.brand}
                required={profile.brandRequired}
              />
            </label>
          )}

          {profile.showColor && profile.colorMode === "select" && (
            <label className="dashboard-form-field">
              <span>Color</span>
              <select name="color" value={form.color} onChange={onChange}>
                <option value="">Select color</option>
                {COLOR_SELECT_OPTIONS.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </label>
          )}

          {profile.showColor && profile.colorMode === "text" && (
            <label className="dashboard-form-field">
              <span>
                {profile.colorLabel || "Color / variant"}
                <CharCount value={form.color} max={PRODUCT_FIELD_LIMITS.color} />
              </span>
              <input
                type="text"
                name="color"
                value={form.color}
                onChange={onChange}
                placeholder={profile.colorPlaceholder || "Optional"}
                maxLength={PRODUCT_FIELD_LIMITS.color}
              />
            </label>
          )}

          {profile.attributeFields.map((field) =>
            renderAttributeField(field, form.attributes?.[field.key], onAttributeChange)
          )}
        </div>
      </section>

      {profile.showSizes && (
        <section className="dashboard-card">
          <div className="dashboard-size-section__header">
            <h2 className="dashboard-card__title">Size variation & stock</h2>
            <span className="dashboard-size-total">
              Total stock: <strong>{sizeTotal}</strong>
            </span>
          </div>
          <p className="dashboard-form-hint">
            {profile.sizeHint ||
              "Enter units in stock for each size. Leave blank for sizes you don't offer."}
          </p>
          <div className="dashboard-size-grid">
            {sizeFields.map(([field, label]) => (
              <label key={field} className="dashboard-size-cell">
                <span className="dashboard-size-cell__label">{label}</span>
                <input
                  type="number"
                  name={field}
                  value={form[field]}
                  onChange={onChange}
                  min="0"
                  max={PRODUCT_FIELD_LIMITS.sizeStock}
                  placeholder="0"
                  inputMode="numeric"
                  aria-label={`Stock for size ${label}`}
                />
              </label>
            ))}
          </div>
        </section>
      )}
    </>
  );
};

export default CategoryProductFields;
